import {SocialAccount, SocialAccountProvider} from "../../../../../client/state/SocialAccountStore";
import {UI} from "../../../../../stem-core/ui/UIBase";
import {UserDashboardSection} from "./UserDashboardSection.jsx";
import {Link} from "../../../../../stem-core/ui/primitives/Link";

export function UserDashboardCDSAccountSection() {
    // TODO When we'll have multiple CDS merchants, there might be a separate CDS social account. Match it by the merchant's publication code.
    const cdsSocialAccount = SocialAccount.find(socialAccount => socialAccount.provider === SocialAccountProvider.CDS && socialAccount.extraData?.handlesSubscriptions);

    const cdsAccountNumber = cdsSocialAccount?.getCDSAccountNumber();

    const cdsURL = "https://service.newrepublic.com/";

    return <UserDashboardSection titleMessage="Customer Care">
        {cdsAccountNumber && <div>
            Your customer support account number is <strong>{cdsAccountNumber}</strong>.
        </div>}
        <div>
            To renew, cancel or update your subscription, billing or delivery details, visit the <Link newTab href={cdsURL} label="Customer Care portal"/>.
        </div>
    </UserDashboardSection>;
}
